export default {"src":"/_next/static/media/return-box.801c67c2.svg","height":800,"width":800};